"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var palette = _interopRequireWildcard(require("../shared/oldDocumentSignerUI/palette"));

var _DialogButton = _interopRequireDefault(require("../DialogButton"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(theme) {
  return {
    root: {
      placeItems: 'center',
      display: 'grid',
      width: '100%',
      gridGap: '2%',
      gap: '2%',
      gridTemplateColumns: 'repeat(3, 32%)'
    },
    buttonBase: {
      flex: 1,
      marginLeft: 5,
      width: '100%'
    },
    label: {
      color: theme.palette.primary.contrastText,
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      fontSize: '.73rem'
    },
    inverseLabel: {
      color: palette.black
    },
    save: {
      backgroundColor: 'white',
      gridColumn: '1'
    },
    accept: {
      gridColumn: '2 '
    },
    cancel: {
      gridColumn: '3',
      marginRight: 5
    },
    documents: {
      display: 'inline',
      fontSize: '0.8em',
      fontWeight: 'bold',
      '& li': {
        float: 'left',
        display: 'inline',
        paddingRight: '10px'
      },
      '& li:before': {
        content: '"• "'
      }
    },
    confirmationCancelText: {
      textTransform: 'none',
      fontStyle: 'italic',
      textDecoration: 'underline'
    },
    confirmationConfirmButton: {
      background: '#536881',
      color: theme.palette.primary.contrastText
    },
    confirmationConfirmText: {
      textTransform: 'none'
    }
  };
};

var ActionButtons = function ActionButtons(props) {
  var actions = props.actions,
      actionButtonClick = props.actionButtonClick,
      classes = props.classes,
      groupedAcknowledgmentDocumentNames = props.groupedAcknowledgmentDocumentNames,
      isOfferComplete = props.isOfferComplete,
      templatesAcknowledgeNotes = props.templatesAcknowledgeNotes,
      templatesAcknowledgeTitle = props.templatesAcknowledgeTitle;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, actions.save && /*#__PURE__*/_react.default.createElement(_DialogButton.default, {
    color: "tertiary",
    variant: "contained",
    className: (0, _classnames.default)(classes.buttonBase, classes.save),
    buttonClasses: {
      label: (0, _classnames.default)(classes.label, classes.inverseLabel)
    },
    onClick: function onClick() {
      return actionButtonClick('save');
    },
    dialogType: "alert",
    dialogTitle: "Your documents have been saved",
    dialogBody: "Please note: Your offer is not complete and will not be submitted for approval until you complete and sign all offer documents. You can login and resume the process.",
    "data-test-id": "ActionButtons-saveButton"
  }, actions.save.text), actions.submit && /*#__PURE__*/_react.default.createElement(_DialogButton.default, {
    color: "primary",
    variant: "contained",
    className: (0, _classnames.default)(classes.buttonBase, classes.accept),
    buttonClasses: {
      label: classes.label
    },
    disabled: !isOfferComplete,
    onClick: function onClick() {
      return actionButtonClick('submit');
    },
    dialogType: groupedAcknowledgmentDocumentNames.length && 'confirmation',
    dialogTitle: templatesAcknowledgeTitle,
    dialogBody: /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_core.Typography, null, templatesAcknowledgeNotes), /*#__PURE__*/_react.default.createElement("ul", {
      className: classes.documents
    }, groupedAcknowledgmentDocumentNames.map(function (name) {
      return /*#__PURE__*/_react.default.createElement("li", null, name);
    }))),
    dialogCancelButton: /*#__PURE__*/_react.default.createElement(_core.Button, {
      fullWidth: true
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: classes.confirmationCancelText
    }, "On second thought, let me review those again...")),
    dialogConfirmButton: /*#__PURE__*/_react.default.createElement(_core.Button, {
      fullWidth: true,
      color: "primary",
      variant: "contained",
      className: classes.confirmationConfirmButton
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: classes.confirmationConfirmText
    }, "I acknowledge receipt of the aforementioned documents")),
    "data-test-id": "ActionButtons-submitButton"
  }, actions.submit.text), actions.cancel && /*#__PURE__*/_react.default.createElement(_core.Button, {
    color: "secondary",
    variant: "contained",
    className: (0, _classnames.default)(classes.buttonBase, classes.cancel),
    classes: {
      label: classes.label
    },
    onClick: function onClick() {
      return actionButtonClick('cancel');
    },
    "data-test-id": "ActionButtons-cancelButton"
  }, actions.cancel.text));
};

var _default = (0, _styles.withStyles)(styles)(ActionButtons);

exports.default = _default;